<template>
  <div class="demo-screen-headline main-demo spacing-top overflow-hidden" id="home">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 col-lg-6">
          <h4 class="fw-semibold mt-7">Manage Your Business</h4>
          <h1 class="fw-bold">
            We Help to Build Your Dream Project with
            <span class="text-primary">Sash</span>
          </h1>
          <p class="pb-3">
            Sash admin template helps you build stunning dashboards faster.
          </p>
          <a class="btn btn-primary me-2">Get Started</a>
          <a class="btn btn-outline-primary">Discover More</a>
        </div>
        <div class="col-xl-6 col-lg-6">
          <img src="/assets/images/landing/3.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HeroSection'
  }
</script>
